import {
  Grid,
  Button,
  Paper,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useState } from 'react';
import DeleteConfirmationDialog from '../../components/DeleteConfirmationDialog';
import GreenButton from '../../components/GreenButton';
import { useDeleteSatellite } from './api/deleteSatellite';
import { useSatellites } from './api/getSatellites';
import SatelliteDialog from './SatelliteDialog';

const SatellitePage = () => {
  const [selectedSatelliteId, setSelectedSatelliteId] = useState<null | number>(
    null
  );
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const { data: satellites } = useSatellites({});
  const deleteSatellite = useDeleteSatellite({});

  const handleNew = () => {
    setSelectedSatelliteId(null);
    setDialogOpen(true);
  };

  const handleDelete = () => {
    setDeleteDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
    setSelectedSatelliteId(null);
  };

  const onSubmitDelete = async () => {
    if (!selectedSatelliteId) return;
    await deleteSatellite.mutateAsync(selectedSatelliteId);
  };

  const onCloseDelete = () => {
    setDeleteDialogOpen(false);
    setSelectedSatelliteId(null);
  };

  return (
    <Grid container spacing={2}>
      <Grid container item xs={12} alignItems='center' spacing={1}>
        <Grid item>
          <GreenButton name='New Satellite' onClick={handleNew}></GreenButton>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            onClick={() => setDialogOpen(true)}
            disabled={!selectedSatelliteId}
          >
            Edit Satellite
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            color='error'
            disabled={!selectedSatelliteId}
            onClick={handleDelete}
          >
            Delete Satellite
          </Button>
        </Grid>
      </Grid>
      <Grid item container>
        <Grid item component={Paper} xs>
          <List>
            {satellites?.map((satellite) => (
              <ListItem
                key={satellite.id}
                button
                onClick={() => setSelectedSatelliteId(satellite.id)}
                selected={selectedSatelliteId === satellite.id}
              >
                <ListItemText primary={satellite.name} />
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
      <SatelliteDialog
        open={dialogOpen}
        handleClose={handleClose}
        satellite={satellites?.find(
          (satellite) => satellite.id === selectedSatelliteId
        )}
      />
      <DeleteConfirmationDialog
        open={deleteDialogOpen}
        itemToDelete={
          satellites?.find((satellite) => satellite.id === selectedSatelliteId)
            ?.name || 'Satellite'
        }
        onSubmit={onSubmitDelete}
        onClose={onCloseDelete}
      />
    </Grid>
  );
};

export default SatellitePage;
